// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import FinanceDimension from "./finance-dimension.js"

const modelClassData = {
  "attributes": {
    "blocked": {
      "column": {
        "default": false,
        "name": "blocked",
        "null": false,
        "type": "boolean"
      },
      "name": "blocked",
      "selected_by_default": null,
      "translated": false
    },
    "code": {
      "column": {
        "default": null,
        "name": "code",
        "null": true,
        "type": "string"
      },
      "name": "code",
      "selected_by_default": null,
      "translated": false
    },
    "travel_locked": {
      "column": {
        "default": true,
        "name": "travel_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "travel_locked",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "nemoa_locked": {
      "column": {
        "default": true,
        "name": "nemoa_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "nemoa_locked",
      "selected_by_default": null,
      "translated": false
    },
    "expense_locked": {
      "column": {
        "default": true,
        "name": "expense_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "expense_locked",
      "selected_by_default": null,
      "translated": false
    },
    "time_locked": {
      "column": {
        "default": true,
        "name": "time_locked",
        "null": false,
        "type": "boolean"
      },
      "name": "time_locked",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "FinanceDimensionValue",
  "collectionKey": "finance_dimension_values",
  "collectionName": "finance_dimension_values",
  "i18nKey": "finance_dimension_value",
  "camelizedLower": "financeDimensionValue",
  "name": "FinanceDimensionValue",
  "nameDasherized": "finance-dimension-value",
  "pluralName": "finance_dimension_values",
  "ransackable_associations": [
    {
      "className": "EmployeePrice",
      "collectionName": "employee_prices",
      "foreignKey": "bearer_id",
      "name": "bearer_on_employee_prices",
      "macro": "has_many",
      "resource_name": "EmployeePrice",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "bearer_id",
      "name": "bearer_on_reimbursements",
      "macro": "has_many",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "finance_dimension_value_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "FinanceDimensionValue::Translation",
      "collectionName": null,
      "foreignKey": "finance_dimension_value_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "FinanceAccountFinanceDimensionValue",
      "collectionName": "finance_account_finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "finance_account_finance_dimension_values",
      "macro": "has_many",
      "resource_name": "FinanceAccountFinanceDimensionValue",
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_accounts",
      "macro": "has_many",
      "resource_name": "FinanceAccount",
      "through": "finance_account_finance_dimension_values"
    },
    {
      "className": "FinanceDimension",
      "collectionName": "finance_dimensions",
      "foreignKey": "finance_dimension_id",
      "name": "finance_dimension",
      "macro": "belongs_to",
      "resource_name": "FinanceDimension",
      "through": null
    },
    {
      "className": "LockedFinanceDimensionValue",
      "collectionName": "locked_finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "locked_finance_dimension_values",
      "macro": "has_many",
      "resource_name": "LockedFinanceDimensionValue",
      "through": null
    },
    {
      "className": "LockedFinanceDimensionValue",
      "collectionName": "locked_finance_dimension_values",
      "foreignKey": "locked_finance_dimension_value_id",
      "name": "locked_finance_dimension_values_locked",
      "macro": "has_many",
      "resource_name": "LockedFinanceDimensionValue",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Reimbursement",
      "collectionName": "reimbursements",
      "foreignKey": "purpose_id",
      "name": "purpose_on_reimbursements",
      "macro": "has_many",
      "resource_name": "Reimbursement",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "FinanceDimensionValue::Translation",
      "collectionName": null,
      "foreignKey": "finance_dimension_value_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "blocked",
      "column": {
        "default": false,
        "name": "blocked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "code",
      "column": {
        "default": null,
        "name": "code",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_in_inventio_at",
      "column": {
        "default": null,
        "name": "deleted_in_inventio_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "expense_locked",
      "column": {
        "default": true,
        "name": "expense_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "finance_dimension_id",
      "column": {
        "default": null,
        "name": "finance_dimension_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "nemoa_locked",
      "column": {
        "default": true,
        "name": "nemoa_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_finance_dimension_id",
      "column": {
        "default": null,
        "name": "old_finance_dimension_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "time_locked",
      "column": {
        "default": true,
        "name": "time_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "travel_locked",
      "column": {
        "default": true,
        "name": "travel_locked",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "not_locked_on_dimension"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_finance_account_locked_asc"
    },
    {
      "name": "sort_by_finance_account_locked_desc"
    },
    {
      "name": "sort_by_finance_dimension_value_locked_asc"
    },
    {
      "name": "sort_by_finance_dimension_value_locked_desc"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "finance_dimension_value_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "FinanceDimension",
      "collectionName": "finance_dimensions",
      "foreignKey": "finance_dimension_id",
      "name": "finance_dimension",
      "macro": "belongs_to",
      "resource_name": "FinanceDimension",
      "through": null
    }
  ],
  "paramKey": "finance_dimension_value",
  "primaryKey": "id"
}

/** Frontend model for FinanceDimensionValue. */
export default class FinanceDimensionValue extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  blocked() {
    return this.readAttributeUnderscore("blocked")
  }

  /** @returns {boolean} */
  hasBlocked() {
    const value = this.blocked()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  code() {
    return this.readAttributeUnderscore("code")
  }

  /** @returns {boolean} */
  hasCode() {
    const value = this.code()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  travelLocked() {
    return this.readAttributeUnderscore("travel_locked")
  }

  /** @returns {boolean} */
  hasTravelLocked() {
    const value = this.travelLocked()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  nemoaLocked() {
    return this.readAttributeUnderscore("nemoa_locked")
  }

  /** @returns {boolean} */
  hasNemoaLocked() {
    const value = this.nemoaLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  expenseLocked() {
    return this.readAttributeUnderscore("expense_locked")
  }

  /** @returns {boolean} */
  hasExpenseLocked() {
    const value = this.expenseLocked()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  timeLocked() {
    return this.readAttributeUnderscore("time_locked")
  }

  /** @returns {boolean} */
  hasTimeLocked() {
    const value = this.timeLocked()

    return this._isPresent(value)
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["finance_dimension_value_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./finance-dimension.js").default | null} */
  financeDimension() {
    return this._readBelongsToReflection({modelClass: FinanceDimension, reflectionName: "finance_dimension"})
  }

  /** @returns {Promise<import("./finance-dimension.js").default | null>} */
  loadFinanceDimension() {
    if (!("financeDimensionId" in this)) throw new Error("Foreign key method wasn't defined: financeDimensionId")

    const id = this.financeDimensionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "finance_dimension",
        model: this,
        modelClass: FinanceDimension
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-dimension.js").default | null>} */
  ensureFinanceDimensionLoaded() {
    return this.ensureAssociationLoaded("finance_dimension")
  }
}
